<template>
  <el-dialog :close-on-click-modal="false" :title="isEdit ? '编辑模板页信息' : '新建模板页信息'" :visible.sync="isShow" width="600px" @closed="closed" append-to-body>
    <el-form ref="form" :model="addModuleInfoVo" :rules="rule" label-width="130px">
      <el-form-item label="模板页信息:" prop="name">
        <el-input v-model="addModuleInfoVo.name" clearable></el-input>
      </el-form-item>
      <el-form-item label="信息类型:" prop="infoType">
        <el-select v-model="addModuleInfoVo.infoType" placeholder="请选择">
          <el-option label="文本" value="TEXT"></el-option>
          <el-option label="图片" value="IMAGE"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否仅显示内容:" v-if="addModuleInfoVo.infoType === 'TEXT'">
        <el-switch v-model="addModuleInfoVo.isOnlyShowContent" active-color="rgba(20, 115, 230, 1)" inactive-color="rgba(140, 140, 140, 1)">
        </el-switch>
      </el-form-item>
      <el-form-item label="限制:" prop="value">
        <el-input v-model.trim="addModuleInfoVo.textValue" placeholder="长度限制" v-show="addModuleInfoVo.infoType === 'TEXT'" clearable></el-input>
        <div v-show="addModuleInfoVo.infoType === 'IMAGE'">
          <el-input style="margin:0px;" v-model.number="addModuleInfoVo.imageValueStart" placeholder="最小图片数"></el-input> — <el-input v-model.number="addModuleInfoVo.imageValueEnd" placeholder="最大图片数">
          </el-input>
        </div>
      </el-form-item>
      <el-form-item label="是否关联设计版:">
        <el-switch v-model="addModuleInfoVo.isAssociatedePtsTemplate" active-color="rgba(20, 115, 230, 1)" inactive-color="rgba(140, 140, 140, 1)">
        </el-switch>
      </el-form-item>
      <el-form-item label="模板页内容:" v-show="addModuleInfoVo.isAssociatedePtsTemplate && addModuleInfoVo.infoType === 'TEXT'">
        <el-input type="textarea" placeholder="请输入内容" :maxlength="addModuleInfoVo.isOnlyShowContent ? addModuleInfoVo.textValue : contentLength" show-word-limit v-model="addModuleInfoVo.content">
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="save">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { moduleInfoAdd, moduleInfoUpdate } from '@/api/auxx.js'
export default {
  data () {
    var value = (rule, value, callback) => {
      if (this.addModuleInfoVo.infoType === 'TEXT') {
        if (!this.addModuleInfoVo.textValue || /[^\d]/g.test(this.addModuleInfoVo.textValue)) {
          callback(new Error('请输入限制，格式为整数'))
        } else {
          callback()
        }
      } else if (this.addModuleInfoVo.infoType === 'IMAGE') {
        if (/[^\d]/g.test(this.addModuleInfoVo.imageValueStart)) {
          console.log('this.addModuleInfoVo.imageValueStart', this.addModuleInfoVo.imageValueStart)
          callback(new Error('请设置上限，格式为整数'))
        } else if (/[^\d]/g.test(this.addModuleInfoVo.imageValueEnd)) {
          callback(new Error('请设置下限，格式为整数'))
        } else if (this.addModuleInfoVo.imageValueStart && !/[^\d]/g.test(this.addModuleInfoVo.imageValueStart) && this.addModuleInfoVo.imageValueEnd && !/[^\d]/g.test(this.addModuleInfoVo.imageValueEnd)) {
          if (this.addModuleInfoVo.imageValueStart > this.addModuleInfoVo.imageValueEnd) {
            callback(new Error('最大图片数不能小于最小图片数'))
          } else {
            callback()
          }
        } else {
          callback()
        }
      }
    }
    return {
      lock: false,
      isShow: false,
      isEdit: false,
      addModuleInfoVo: {
        content: '',
        isAssociatedePtsTemplate: false,
        isOnlyShowContent: false,
        infoType: 'TEXT',
        imageValueStart: '',
        imageValueEnd: '',
        textValue: '',
        name: ''
      },
      rule: {
        name: [
          { required: true, message: '请输入信息名称', trigger: 'blur' }
          // { max: 25, message: '长度25个字以内', trigger: 'blur' } 
        ],
        infoType: [
          { required: true, message: '请选择信息类型', trigger: 'change' }
        ],
        value: [
          { validator: value, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    contentLength () {
      return Number(this.addModuleInfoVo.textValue) + Number(this.addModuleInfoVo.name.length) + 1
    }
  },
  methods: {
    isOnlyShowContentChange (val) {
      console.log('val', val)
    },
    /**
   * @param {boolean}isEdit 修改/新增
   * @param {Object}scope 修改时行内容
   */
    show (isEdit, scope) {
      this.isEdit = isEdit
      if (isEdit) {
        this.addModuleInfoVo.infoId = scope.row.infoId
        this.addModuleInfoVo.infoType = scope.row.infoType
        this.addModuleInfoVo.name = scope.row.name
        this.addModuleInfoVo.isAssociatedePtsTemplate = scope.row.isAssociatedePtsTemplate
        this.addModuleInfoVo.content = scope.row.content
        if (scope.row.infoType === 'TEXT') {
          this.addModuleInfoVo.textValue = scope.row.infoValue
          this.addModuleInfoVo.isOnlyShowContent = scope.row.isOnlyShowContent
        } else if (scope.row.infoType === 'IMAGE') {
          this.addModuleInfoVo.imageValueStart = scope.row.infoValue.split('-')[0]
          this.addModuleInfoVo.imageValueEnd = scope.row.infoValue.split('-')[1]
        }
      }
      this.isShow = true
    },
    save () {
      console.log('valid', 'xinzneg ')
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return
        }
        if (this.addModuleInfoVo.isAssociatedePtsTemplate && this.addModuleInfoVo.infoType === 'TEXT') {
          if (this.addModuleInfoVo.isOnlyShowContent) {
            console.log('1')
            if (this.addModuleInfoVo.content?.length < +this.addModuleInfoVo.textValue) {
              this.$message.error('文本数量不足限制，请确认')
              return
            } else if (this.addModuleInfoVo.content?.length > +this.addModuleInfoVo.textValue) {
              this.$message.error('文本数量多于限制，请确认')
              return
            }
          } else {
            console.log('2', +this.contentLength)
            if (this.addModuleInfoVo.content?.length < +this.addModuleInfoVo.textValue) {
              this.$message.error('文本数量不足限制，请确认')
              return
            }
          }
        }
        let vo = {
          attachType: 'HQ',
          infoType: this.addModuleInfoVo.infoType,
          infoValue: '',
          name: this.addModuleInfoVo.name,
          content: this.addModuleInfoVo.content,
          isAssociatedePtsTemplate: this.addModuleInfoVo.isAssociatedePtsTemplate
        }
        if (vo.infoType === 'TEXT') {
          vo.infoValue = this.addModuleInfoVo.textValue
          vo.isOnlyShowContent = this.addModuleInfoVo.isOnlyShowContent
        } else if (vo.infoType === 'IMAGE') {
          vo.infoValue = this.addModuleInfoVo.imageValueStart + '-' + this.addModuleInfoVo.imageValueEnd
        }
        if (this.lock) {
          this.$message.error('正在提交，请勿重复提交')
          return
        }
        this.lock = true
        if (this.isEdit) {
          vo.infoId = this.addModuleInfoVo.infoId
          moduleInfoUpdate(vo)
            .then(res => {
              this.lock = false
              if (res.data.success) {
                this.$message.success('编辑成功')
                this.$emit('success')
                this.isShow = false
              }
            })
        } else {
          console.log('新增')
          moduleInfoAdd(vo)
            .then(res => {
              this.lock = false
              if (res.data.success) {
                this.$message.success('新建成功')
                this.$emit('success')
                this.isShow = false
              }
            })
        }
      })
    },
    closed () {
      this.addModuleInfoVo.infoType = 'TEXT'
      this.addModuleInfoVo.imageValueStart = ''
      this.addModuleInfoVo.imageValueEnd = ''
      this.addModuleInfoVo.textValue = ''
      this.addModuleInfoVo.name = ''
      this.addModuleInfoVo.content = ''
      this.$refs.form.resetFields()
    }
  }
}
</script>
<style></style>
